import React, {useEffect} from 'react';
import PaymentTime from './PaymentTime.js';
import {
  getStorageElement,
} from '../../../../services/storage.service';
import { ORDER_ID, LOCAL_STORAGE } from '../../../../constants';
import Translation from '../../../../services/translation.service';
import './index.scss';
import { setRoute } from 'stores/Layout/layoutActions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

function Index(props) {
  let orderIDtmp = getStorageElement(ORDER_ID, LOCAL_STORAGE);
  const { setRoute, routeId } = props;
  useEffect(() => {
    setRoute({ name: 'business/payment', id: routeId });
    }, [setRoute, routeId])
  return (
    <div>
      <div className="mainWrapper">
        <div className="shape-rectangle-header">
          <div className="shape-title">{Translation.key('b2b_payment')}</div>
        </div>
        <div>{orderIDtmp !== null && <PaymentTime orderID={orderIDtmp} />}</div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
      pageContent: state.layout.pageContent
  }
};
const mapDispatchToProps = dispatch => {
  return bindActionCreators({ setRoute }, dispatch);
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Index);
